module.exports = __webpack_public_path__ + "img/head.e03fcb03.png";